export const defaultStyle = {
    wrapper: "relative",
    yellow: "tag uppercase px-[8px] py-[6px] border-[0.5px] border-darkGrey bg-yellow text-black h-fit",
    blue: "tag uppercase px-[8px] py-[6px] border-[0.5px] border-darkGrey bg-blue text-black h-fit",
    beige: "tag uppercase px-[8px] py-[6px] border-[0.5px] border-darkGrey bg-beige text-black h-fit",
}

